<template>
    <div class="funItem">
        <div class="itemTitle">{{ title }}</div>
        <div :style="{ backgroundImage: `url('${dataInfo.bg_url}')` }" class="twoImageCom">
            <div class="twoImageBox">
                <div class="imagOne">
                    <div class="title">{{ dataInfo.left_title }}</div>
                    <img class="imag" :src="dataInfo.left_cover" alt="" />
                </div>
                <div class="imagOne">
                    <div class="title">{{ dataInfo.right_title }}</div>
                    <img class="imag" :src="dataInfo.right_cover" alt="" />
                </div>
            </div>
        </div>
        <div class="bottomText">{{ dataInfo.title }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        dataInfo: {
            type: Object,
            default: (() => { })
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.funItem {
    margin-top: 0px;
    margin-bottom: 116px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        width: 1200px;
        margin: auto;
    }

    .twoImageCom {
        background: #F7F7F7;
        margin-top: 38px;
        background-size: cover;
        background-position: center;

        .twoImageBox {
            width: 1200px;
            margin: auto;
            display: flex;

            .imagOne {
                width: 50%;
                position: relative;

                .title {
                    font-weight: 500;
                    font-size: 18px;
                    color: #231815;
                }

                &:nth-child(1) {
                    .title {
                        position: absolute;
                        right: 46px;
                        top: 48px;
                    }
                }

                &:nth-child(2) {
                    .title {
                        position: absolute;
                        left: 46px;
                        top: 48px;
                    }
                }

                .imag {
                    width: 100%;
                    height: 700px;
                    object-fit: cover;
                    display: block;
                }
            }
        }
    }

    .bottomText {
        width: 1200px;
        margin: auto;
        margin-top: 40px;
        font-weight: 500;
        font-size: 21px;
        color: #000000;
    }
}

@media screen and (max-width:1200px) {
    .funItem {
        margin-top: 20px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            width: 100%;
            margin: auto;
        }

        .twoImageCom {
            background: #F7F7F7;
            margin-top: 20px;

            .twoImageBox {
                width: 100%;
                margin: auto;
                display: flex;

                .imagOne {
                    width: 50%;
                    position: relative;

                    .title {
                        font-weight: 500;
                        font-size: 12px;
                        color: #231815;
                        width: 100%;
                        text-align: center;
                    }

                    &:nth-child(1) {
                        .title {
                            position: absolute;
                            right: 0px;
                            top: 18px;
                        }
                    }

                    &:nth-child(2) {
                        .title {
                            position: absolute;
                            left: 0px;
                            top: 18px;
                        }
                    }

                    .imag {
                        width: 100%;
                        height: auto;
                        object-fit: cover;
                        display: block;
                    }
                }
            }
        }

        .bottomText {
            width: 1200px;
            margin: auto;
            margin-top: 40px;
            font-weight: 500;
            font-size: 21px;
            color: #000000;
        }
    }
}
</style>